module.exports = __webpack_public_path__ + "img/ufton_b5.e7cddae2.jpg";